<template>
<div>
  欢迎使用
</div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { Message } from 'element-ui'
export default {
  name: 'enterpriseindex',
  beforeCreate () {
    var that = this
    // eslint-disable-next-line no-useless-escape
    var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
    var regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
    const tokendecode = decodeURIComponent(that.$route.query.token).replace(/[`～*~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, '')
    if (regEn.test(that.$route.query.token) || regCn.test(that.$route.query.token)) {
      Message({
        message: '非法账号',
        type: 'error',
        duration: 5 * 1000
      })
      return false
    } else {
      if (rootPathssb.sso) {
        console.log(that.$route.query.token)
        localStorage.setItem('User-Auth', tokendecode)
      }
    }
  } // 页面加载时

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriseindex.vue